import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
}

/**
 * Error Boundary for the Titlebar component.
 *
 * Catches render errors in the Titlebar tree and displays a minimal
 * fallback (empty drag area) so the window remains draggable and
 * the rest of the app keeps working.
 */
export class TitlebarErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[TitlebarErrorBoundary]', error, info.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="titlebar">
          <div className="titlebar__drag-area" />
        </div>
      )
    }
    return this.props.children
  }
}
